/**
 * Firebase Analytics wrapper.
 *
 * - Lazy-loads the Firebase SDK on first use (keeps it out of the initial bundle).
 * - Never runs during prerender (the prerender browser sets a "Prerender" UA),
 *   so no phantom events and the static HTML stays clean.
 * - `track()` is fire-and-forget and fully guarded — analytics can never break
 *   the app.
 */
const firebaseConfig = {
  apiKey: "AIzaSyC0LlpeM-Umr14EmwSXDYm6IB9sZNwfl_k",
  authDomain: "eps-viewer-website.firebaseapp.com",
  projectId: "eps-viewer-website",
  storageBucket: "eps-viewer-website.firebasestorage.app",
  messagingSenderId: "537467529385",
  appId: "1:537467529385:web:56eb280b5d3fb62e0c61b8",
  measurementId: "G-2TBK3G2P1X",
};

const isBrowser = typeof window !== "undefined";
const isPrerender = isBrowser && /Prerender/i.test(navigator.userAgent || "");

let readyPromise = null;

function getAnalytics_() {
  if (!isBrowser || isPrerender) return Promise.resolve(null);
  if (!readyPromise) {
    readyPromise = (async () => {
      try {
        const [{ initializeApp, getApps }, mod] = await Promise.all([
          import("firebase/app"),
          import("firebase/analytics"),
        ]);
        const supported = await mod.isSupported().catch(() => false);
        if (!supported) return null;
        const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
        return { instance: mod.getAnalytics(app), logEvent: mod.logEvent };
      } catch {
        return null;
      }
    })();
  }
  return readyPromise;
}

export function track(name, params = {}) {
  getAnalytics_().then((a) => {
    if (!a) return;
    try {
      a.logEvent(a.instance, name, params);
    } catch {
      /* ignore */
    }
  });
}

export function logPageView(path) {
  track("page_view", {
    page_path: path,
    page_location: isBrowser ? window.location.href : path,
    page_title: isBrowser ? document.title : undefined,
  });
}
